export default {
  places: [],
  place: null,
  placesCount: 0,
  query: {},
  limit: 10,
  skip: 0,
  sort: {}
}
